import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Ordem importa: primeiro os tokens do gov.br DS, depois o CSS dos
// componentes, e por ultimo a NOSSA camada de tema — que sobrescreve o nivel
// semantico para o modo escuro (SPEC 8.2). Inverter a ordem faria o DS ganhar
// e o tema escuro nao aplicar.
// Font Awesome 5 Free ANTES do core do DS.
//
// O @govbr-ds/core declara `font-family: "Font Awesome 5 Free"` nos seus
// pseudo-elementos mas NAO distribui a fonte — ela e dependencia externa. Sem
// esta linha, todo <i className="fas fa-..."> renderiza um quadrado vazio, o
// que deixou a interface inteira sem icone.
//
// Precisa ser a v5: a v6 registra a familia como "Font Awesome 6 Free" e nao
// casaria com o que o DS procura.
//
// Importamos SO o nucleo + o estilo solid, nao o `all.min.css`. O pacote
// completo traz tambem `regular` e `brands` — e `brands` sozinho sao 748 kB de
// SVG que o service worker precacharia no celular do motorista. O app usa
// exclusivamente `fas` (solid): 41 ocorrencias, zero de `far` ou `fab`.
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'

import '@govbr-ds/core/dist/core-tokens.min.css'
import '@govbr-ds/core/dist/core.min.css'
import './theme/tokens.css'
import './theme/design.css'
import './theme/widgets.css'
import './theme/layout.css'
import './theme/inicio.css'

import { App } from './App'
import { ThemeProvider } from './theme/ThemeProvider'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado no index.html')

createRoot(raiz).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)
